module.exports = __webpack_public_path__ + "img/varsha.04f34380.webp";